let cantidadPacks = 1; 

// Función para hacer scroll suave desde el botón de la Narrativa hasta la sección de Compra
function scrollToCompra() {
    // Hace scroll suave hasta la sección de la crema
    const compraSection = document.getElementById('compra');
    compraSection.scrollIntoView({ 
        behavior: 'smooth' 
    });
}

// Función para navegar a la página de producto
function navegarAlProducto() {
    console.log("Navegando al producto...");
    window.location.href = '/products/linna-collagen-22-plus';
}

// Función para el scroll de la flecha en el inicio
function scrollToNarrativa() {
    const narrativaSection = document.getElementById('narrativa');
    if (narrativaSection) {
        narrativaSection.scrollIntoView({ 
            behavior: 'smooth' 
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const allTracks = document.querySelectorAll('.ticker-track');

    allTracks.forEach(track => {
        // Detecta tanto imágenes como vectores SVG
        const logo = track.querySelector('img, svg');
        if (logo) {
            const logoClone = logo.cloneNode(true);
            track.innerHTML = ''; 

            for (let i = 0; i < 18; i++) {
                track.appendChild(logoClone.cloneNode(true));
            }
            track.classList.add('animating');
        }
    });
});

// =========================================================
// 2. LÓGICA DE SELECCIÓN DE OFERTAS Y APERTURA DE CARRITO
// =========================================================
document.addEventListener("DOMContentLoaded", function() {
    const tarjetas = document.querySelectorAll('.offer-card');

    tarjetas.forEach(tarjeta => {
        tarjeta.addEventListener('click', function() {
            // Quitar selección previa y seleccionar la tarjeta clickeada
            tarjetas.forEach(t => t.classList.remove('selected'));
            this.classList.add('selected');

            // Feedback táctil suave
            if (window.navigator.vibrate) window.navigator.vibrate(15);

            // AGREGAR DIRECTAMENTE AL SERVIDOR DE SHOPIFY Y ABRIR EL CARRITO
            agregarAlCarrito(); 
        });
    });
});

function toggleDiscount() {
    const content = document.getElementById('discount-content');
    const icon = document.getElementById('discount-icon');
    
    if (content && icon) {
        // Alternamos la clase open
        content.classList.toggle('open');
        
        // Cambiamos el icono de + a − (guion medio)
        if (content.classList.contains('open')) {
            icon.textContent = '−';
        } else {
            icon.textContent = '+';
        }
    }
}

// FUNCIÓN PARA SIMULAR ERROR DE CUPÓN (FEEDBACK NEGATIVO)
function aplicarCupon() {
    const inputGroup = document.querySelector('.discount-input-group');
    const input = inputGroup ? inputGroup.querySelector('input') : null;
    
    if (!inputGroup || !input) return;

    // 1. Reiniciar la animación de vibración (por si hace clics seguidos)
    inputGroup.classList.remove('coupon-error-shake');
    void inputGroup.offsetWidth; // Truco de reflow para reiniciar la animación CSS

    // 2. Aplicar la vibración visual y el borde rojo
    inputGroup.classList.add('coupon-error-shake');

    // 3. Crear y mostrar el mensaje de error abajo
    let errorMsg = document.getElementById('coupon-error-msg');
    if (!errorMsg) {
        errorMsg = document.createElement('p');
        errorMsg.id = 'coupon-error-msg';
        errorMsg.className = 'coupon-error-txt';
        // Lo insertamos debajo de la caja de texto
        inputGroup.parentNode.appendChild(errorMsg);
    }
    
    errorMsg.textContent = "Código no válido o vencido";
    errorMsg.style.display = 'block';

    // 4. Vibración física del móvil (Doble latido de error)
    if (window.navigator.vibrate) {
        window.navigator.vibrate([80, 50, 80]); 
    }
}

// --- LÓGICA DE RESEÑAS REALISTAS E INTERCALADAS ---
document.addEventListener("DOMContentLoaded", function() {
    const hiddenContainer = document.getElementById('hidden-reviews');
    const btnLoadMore = document.getElementById('btn-load-more');

    if (!hiddenContainer) return;

    let indiceActual = 0;
    const cantidadPorLote = 6;

    const coloresGoogle = ["#5c95d2", "#5c6bc0", "#27ae60", "#e91e63", "#9c27b0", "#ff5722", "#00acc1", "#3949ab", "#43a047"];
    
    // Nombres realistas y variados (apodos, redes, mezclas normales)
    const nombres = [
        "GraciG", "valen_cba", "Maca Gómez", "caro.rossi", "sofi_bianchi", 
        "Lau Alvarez", "Romi_V", "pao_mza", "Flor B.", "agus_gonzalez", 
        "Maru S.", "mariana.perez", "Cami D.", "naty_78", "Vane_martinez", 
        "solcitomza", "Beli", "ana_laura_88", "Silvi P.", "lula_v", 
        "dani.rodriguez", "Marce_G", "agus.tinita", "ClauG", "miri_santoro",
        "Lucre", "pame_c", "lorena.f", "Florchu", "maru_benitez"
    ];

    // Frases intercaladas: algunas con texto y otras VACÍAS (solo estrellas)
    const frases = [
        "Me dejó la piel súper suave desde la primera noche, se absorbe al toque.",
        "", // Solo estrellas
        "Increíble la textura, no te deja nada pesado ni grasoso el rostro.",
        "", // Solo estrellas
        "La uso todas las noches, noto la piel mucho más luminosa y firme.",
        "", // Solo estrellas
        "El envase push es súper higiénico y práctico, 10/10.",
        "La súper recomiendo, te deja efecto piel de cristal posta.",
        "", // Solo estrellas
        "Hermosa emulsión, rinde un montón con poquito producto.",
        "", // Solo estrellas
        "Se nota la calidad de los activos, no me irritó nada.",
        "", // Solo estrellas
        "Excelente compra, llegó rápido y el cambio en la textura se nota."
    ];

    function cargarLote() {
        hiddenContainer.style.display = 'grid';

        const limite = Math.min(indiceActual + cantidadPorLote, nombres.length);
        
        for (let i = indiceActual; i < limite; i++) {
            const nombre = nombres[i];
            const frase = frases[i % frases.length];
            const colorAsignado = coloresGoogle[i % coloresGoogle.length];
            
            // Toma la primera letra del nombre para el avatar
            const letraAvatar = nombre.replace(/[^a-zA-Z]/g, '').charAt(0).toUpperCase() || 'U';

            const div = document.createElement('div');
            div.className = 'review-item'; 
            
            // Si tiene texto lo muestra; si está vacío, solo deja las 5 estrellas
            const textoHtml = frase ? `<p class="review-text">${frase}</p>` : '';

            div.innerHTML = `
                <div class="review-header">
                    <div class="user-avatar" style="background-color: ${colorAsignado}">${letraAvatar}</div>
                    <div class="user-info">
                        <div class="user-name">${nombre}</div>
                    </div>
                </div>
                <div class="review-stars">★★★★★</div>
                ${textoHtml}
            `;
            hiddenContainer.appendChild(div);
        }

        indiceActual = limite;

        if (indiceActual >= nombres.length) {
            if (btnLoadMore) btnLoadMore.style.display = 'none';
        } else {
            if (btnLoadMore) btnLoadMore.innerText = `Ver más opiniones`;
        }
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener('click', cargarLote);
    }
});

// Función auxiliar para abrir el carrito (asegúrate de que los IDs coincidan con tu HTML)
function abrirCarritoManual() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    
    if (drawer && overlay) {
        drawer.classList.add('open');
        overlay.classList.add('show');
    }
}


function startTimer(duration, display) {
    let timer = duration, hours, minutes, seconds;
    setInterval(function () {
        hours = parseInt(timer / 3600, 10);
        minutes = parseInt((timer % 3600) / 60, 10);
        seconds = parseInt(timer % 60, 10);

        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = hours + ":" + minutes + ":" + seconds;

        if (--timer < 0) {
            timer = duration; // Reinicia cuando llega a cero para mantener el loop
        }
    }, 1000);
}

window.onload = function () {
    let twoHours = 60 * 60 * 2 + 60 * 23 + 42; // 02:23:42
    let display = document.querySelector('#timer');
    if(display) startTimer(twoHours, display);
};

function agregarAlCarrito() {
    const ofertaSeleccionada = document.querySelector('.offer-card.selected');
    if (!ofertaSeleccionada) return;

    // Al elegir una nueva promoción, reiniciamos el conteo
    cantidadPacks = 1; 

    const variantId = parseInt(ofertaSeleccionada.getAttribute('data-variant-id'));

    // --------------------------------------------------
    // ACCIÓN VISUAL LOCAL INSTANTÁNEA (0ms de retraso)
    // --------------------------------------------------
    actualizarTotales();                 // Actualiza de inmediato textos y precios en el drawer
    actualizarVisualizacionLocal(false); // Muestra el producto, oculta el vacío y activa el footer
    abrirCarritoManual();                // Abre el panel lateral al instante

    // --------------------------------------------------
    // PROCESAMIENTO EN SEGUNDO PLANO (Silencioso y sin impedimentos)
    // --------------------------------------------------
    fetch('/cart/clear.js', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    })
    .then(() => {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: 1
                }]
            })
        });
    })
    .then(response => {
        return response.json();
    })
    .then(cartData => {
        console.log("Carga silenciosa completada con éxito:", cartData);
    })
    .catch(error => {
        // Captura silenciosa en consola. Deja que el checkout sea quien valide el stock final.
        console.warn("Validación de inventario delegada al checkout:", error);
    });
}

function scrollAPromocionesConRetraso() {
    const promosSection = document.querySelector('.mega-promos-container') || document.getElementById('compra');
    if (promosSection) {
        // Un pequeño retraso de 300ms permite que el drawer termine de cerrarse antes de iniciar el scroll de la página
        setTimeout(() => {
            promosSection.scrollIntoView({ 
                behavior: 'smooth' 
            });
        }, 300);
    }
}

// --- ACTUALIZACIÓN DE CERRAR CARRITO MANUAL (Botón "Ver promociones") ---
function cerrarCarritoManual() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    
    if (drawer && overlay) {
        drawer.classList.remove('open');
        overlay.classList.remove('show');
        
        // Si el carrito está vacío, nos deslizamos hacia las ofertas
        if (cantidadPacks === 0) {
            scrollAPromocionesConRetraso();
        }
    }
}

function iniciarCompraDirecta() {
    const ofertaSeleccionada = document.querySelector('.offer-card.selected');
    if (!ofertaSeleccionada) return;

    const variantId = parseInt(ofertaSeleccionada.getAttribute('data-variant-id'));

    // 1. Vaciamos de forma silenciosa el carrito para evitar que se acumulen ofertas anteriores
    fetch('/cart/clear.js')
    .then(() => {
        // 2. Redirigimos directo al checkout de Shopify con la variante elegida
        window.location.href = `/cart/${variantId}:1`;
    })
    .catch(error => {
        console.error("Error al procesar la compra directa:", error);
        // Intento de rescate si el vaciado falla
        window.location.href = `/cart/${variantId}:1`;
    });
}

// Abrir y Cerrar Carrito
function toggleCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    
    if (drawer && overlay) {
        // Evaluamos si el carrito se va a cerrar en este clic
        const seEstaCerrando = drawer.classList.contains('open');
        
        drawer.classList.toggle('open');
        overlay.classList.toggle('show');
        
        // Si se cerró y el carrito estaba vacío, nos deslizamos hacia las ofertas
        if (seEstaCerrando && cantidadPacks === 0) {
            scrollAPromocionesConRetraso();
        }
    }
}



// --- EFECTO MINIMALISTA: MOSTRAR SCROLL SOLO AL NAVEGAR Y OCULTAR TRAS 1 SEGUNDO ---
document.addEventListener("DOMContentLoaded", function () {
    let scrollTimeout;
    const htmlElement = document.documentElement;

    window.addEventListener("scroll", function () {
        // Añadimos la clase para hacer visible la línea de scroll
        htmlElement.classList.add("is-scrolling");

        // Limpiamos el temporizador anterior para que no se oculte mientras sigas moviéndote
        clearTimeout(scrollTimeout);

        // Ocultamos la barra de scroll exactamente 1 segundo (1000ms) después de detener el scroll
        scrollTimeout = setTimeout(function () {
            htmlElement.classList.remove("is-scrolling");
        }, 1000);
    }, { passive: true }); // "passive: true" mejora el rendimiento de scroll en dispositivos móviles
});

function changeQty(amount) {
    const ofertaSeleccionada = document.querySelector('.offer-card.selected');
    if (!ofertaSeleccionada) return;

    const variantId = parseInt(ofertaSeleccionada.getAttribute('data-variant-id'));
    
    let cambio = parseInt(amount);
    cantidadPacks += cambio;

    // Si la cantidad de packs llega a 0, se vacía por completo el carrito de inmediato
    if (cantidadPacks < 1) {
        vaciarCarritoTotalmente();
        return;
    }

    // --------------------------------------------------
    // ACCIÓN VISUAL LOCAL INSTANTÁNEA (0ms)
    // --------------------------------------------------
    actualizarTotales(); // Modifica los números en pantalla al instante [2]

    // --------------------------------------------------
    // PROCESAMIENTO EN SEGUNDO PLANO (Silencioso)
    // --------------------------------------------------
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: variantId,
            quantity: cantidadPacks
        })
    })
    .then(response => response.json())
    .then(cartData => {
        console.log("Cantidad de packs actualizada silenciosamente:", cartData);
    })
    .catch(error => console.error("Error al actualizar cantidad:", error));
}

function vaciarCarritoTotalmente() {
    // Latido táctil en celulares (doble pulso de advertencia)
    if (window.navigator.vibrate) window.navigator.vibrate([60, 40, 60]);

    // --------------------------------------------------
    // ACCIÓN VISUAL LOCAL INSTANTÁNEA (0ms de retraso)
    // --------------------------------------------------
    cantidadPacks = 0;
    actualizarVisualizacionLocal(true); // Oculta el producto, muestra el vacío y apaga el footer de inmediato

    // --------------------------------------------------
    // PROCESAMIENTO EN SEGUNDO PLANO (Silencioso)
    // --------------------------------------------------
    // CORRECCIÓN: Se agrega { method: 'POST' } para vaciar en el servidor
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    })
    .then(() => {
        console.log("Servidor de Shopify vaciado con éxito");
    })
    .catch(error => console.error("Error al vaciar en servidor:", error));
}
function actualizarVisualizacionLocal(estaVacio) {
    const itemContainer = document.getElementById('cart-item-container');
    const emptyState = document.getElementById('cart-empty-state');
    const footerContent = document.querySelector('.cart-footer-content');
    const cartBadge = document.querySelector('.cart-badge');
    const cartCountTitle = document.getElementById('cart-count-title');

    if (!itemContainer || !emptyState) return;

    if (estaVacio) {
        // CASO: EL CARRITO SE DEBE MOSTRAR VACÍO [2]
        itemContainer.style.display = 'none';
        emptyState.style.display = 'flex';
        if (footerContent) footerContent.style.display = 'none';
        if (cartBadge) cartBadge.style.display = 'none';
        if (cartCountTitle) cartCountTitle.textContent = '0';
    } else {
        // CASO: EL CARRITO TIENE PRODUCTO ACTIVO [2]
        itemContainer.style.display = 'flex';
        emptyState.style.display = 'none';
        if (footerContent) footerContent.style.display = 'block';
        if (cartBadge) {
            cartBadge.textContent = cantidadPacks;
            cartBadge.style.display = 'flex';
        }
        if (cartCountTitle) cartCountTitle.textContent = cantidadPacks;
    }
}
function sincronizarVistaCarritoInicial() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        if (cart.item_count > 0) {
            // Si el usuario ya tenía productos de una sesión previa, leemos sus cantidades
            cantidadPacks = cart.items[0].quantity;
            actualizarVisualizacionLocal(false);
            actualizarTotales();
        } else {
            actualizarVisualizacionLocal(true);
        }
    })
    .catch(error => console.error("Error inicial de sincronización:", error));
}
window.addEventListener('DOMContentLoaded', sincronizarVistaCarritoInicial);



function sincronizarVistaCarrito() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        const itemContainer = document.getElementById('cart-item-container');
        const emptyState = document.getElementById('cart-empty-state');
        const footerContent = document.querySelector('.cart-footer-content');
        const cartBadge = document.querySelector('.cart-badge');
        const cartCountTitle = document.getElementById('cart-count-title');

        if (!itemContainer || !emptyState) return;

        // Actualizamos el número de la cabecera del carrito
        if (cartCountTitle) cartCountTitle.textContent = cart.item_count;

        if (cart.item_count > 0) {
            // Caso: El carrito tiene productos
            itemContainer.style.display = 'flex';
            emptyState.style.display = 'none';
            if (footerContent) footerContent.style.display = 'block';
            if (cartBadge) {
                cartBadge.textContent = cart.item_count;
                cartBadge.style.display = 'flex';
            }
        } else {
            // Caso: El carrito está vacío [2]
            itemContainer.style.display = 'none';
            emptyState.style.display = 'flex';
            if (footerContent) footerContent.style.display = 'none';
            if (cartBadge) cartBadge.style.display = 'none';
        }
    })
    .catch(error => console.error("Error al verificar estado del carrito:", error));
}

function actualizarTotales() {
    try {
        const ofertaSeleccionada = document.querySelector('.offer-card.selected') || document.querySelector('.offer-card');
        if (!ofertaSeleccionada) return;

        // 1. Obtener precio base de la tarjeta seleccionada
        const rawPriceCents = parseInt(ofertaSeleccionada.getAttribute('data-price')) || 5999000;
        const precioBase = rawPriceCents / 100;
        const totalMatematico = precioBase * cantidadPacks;

        const totalFormateado = "$" + totalMatematico.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const precioBaseFormateado = "$" + precioBase.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

        // 2. Título de la promo en el carrito (2 renglones limpios)
        const tagPromo = ofertaSeleccionada.querySelector('.pill-promo-tag')?.textContent.trim() || '';
        const pagasText = ofertaSeleccionada.querySelector('.offer-sub-pay')?.textContent.trim() || '';

        const itemTitle = document.getElementById('cart-item-title');
        if (itemTitle) {
            let baseTitle = (itemTitle.getAttribute('data-base-title') || "REGEN 22⁺ PLUS")
                .replace(/LINNA\s*[—–-]\s*/gi, '')
                .trim();
            
            const textoPromo = tagPromo ? `PROMO ${tagPromo}` : 'PROMO';

            itemTitle.innerHTML = `
                <span class="cart-title-promo">${textoPromo} ${pagasText}</span>
                <span class="cart-title-product">${baseTitle}</span>
            `;
        }

        // 3. Miniatura de la tarjeta
        const urlMiniatura = ofertaSeleccionada.getAttribute('data-image-url');
        const itemImg = document.querySelector('.item-img img');
        if (itemImg && urlMiniatura) {
            itemImg.src = urlMiniatura;
        }

        // 4. Precio anterior tachado en rojo en el carrito
        const delEl = ofertaSeleccionada.querySelector('.old-price-card del') || ofertaSeleccionada.querySelector('.old-price-card');
        let precioViejoTexto = "";
        if (delEl) {
            let textoLimpio = delEl.textContent.replace('ANTES', '').trim();
            // Si tiene coma decimal (ej: ,00), quitamos los centavos
            if (textoLimpio.includes(',')) {
                textoLimpio = textoLimpio.split(',')[0];
            }
            const numOld = parseInt(textoLimpio.replace(/[^0-9]/g, ''), 10);
            if (!isNaN(numOld) && numOld > 0) {
                const totalViejo = numOld * cantidadPacks;
                // Formato limpio argentino sin decimales
                precioViejoTexto = "$" + totalViejo.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            } else {
                precioViejoTexto = delEl.textContent.replace('ANTES', '').trim();
            }
        }

        const itemPrice = document.querySelector('.item-price');
        if (itemPrice && precioViejoTexto) {
            itemPrice.innerHTML = `<span class="cart-old-price-label">PRECIO ANTES: </span><span class="cart-old-price-red">${precioViejoTexto}</span>`;
        }

        // 5. Cantidad y Totales del Carrito
        const itemQty = document.getElementById('item-qty');
        if (itemQty) itemQty.textContent = cantidadPacks; 

        const itemTotalPrice = document.querySelector('.item-total-price');
        if (itemTotalPrice) itemTotalPrice.textContent = totalFormateado;

        const finalPrice = document.querySelector('.final-price');
        if (finalPrice) finalPrice.textContent = totalFormateado;

        // 6. Sincroniza también el precio de la landing (debajo de Moria)
        const mainPriceTag = document.querySelector('.price-tag');
        if (mainPriceTag) mainPriceTag.textContent = precioBaseFormateado;

        const mainOldPriceTag = document.querySelector('.price-label-old .strikethrough');
        if (mainOldPriceTag && precioViejoTexto) mainOldPriceTag.textContent = precioViejoTexto;

    } catch (err) {
        console.error("Error al actualizar totales:", err);
    }
}
window.addEventListener('DOMContentLoaded', sincronizarVistaCarrito);

function irAlPago() {
    const ofertaSeleccionada = document.querySelector('.offer-card.selected');
    if (!ofertaSeleccionada) {
        window.location.href = '/checkout';
        return;
    }

    const variantId = parseInt(ofertaSeleccionada.getAttribute('data-variant-id'));

    // Redirige usando el formato seguro de Shopify para cargar exactamente la variante y cantidad elegida.
    // Esto previene cualquier problema de caché o demoras de red.
    window.location.href = `/cart/${variantId}:${cantidadPacks}`;
}
function seleccionarOferta(elemento) {
    // 1. Obtener todas las tarjetas
    const tarjetas = document.querySelectorAll('.offer-card');
    
    // 2. Quitar la clase 'selected' de todas
    tarjetas.forEach(t => t.classList.remove('selected'));
    
    // 3. Añadir la clase 'selected' solo a la que tocamos
    elemento.classList.add('selected');

    // 4. (Opcional) Actualizar precio en el botón principal
    // Si tienes un botón que debe mostrar el precio de la oferta elegida,
    // puedes capturar el valor aquí.
    const nuevoPrecio = elemento.querySelector('.current-price-card').textContent;
    console.log("Oferta seleccionada: " + nuevoPrecio);
}

// Función para mostrar errores traducidos en el carrito sin usar alert() de Chrome
function mostrarErrorCarrito(mensajeDeError) {
    const errorBanner = document.getElementById('cart-error-banner');
    if (!errorBanner) return;

    let mensajeEspanol = "No se pudo procesar la compra. Inténtalo más tarde.";
    
    // Traducir los errores de Shopify o stock al español
    if (mensajeDeError.includes("stock") || mensajeDeError.includes("available") || mensajeDeError.includes("out of stock") || mensajeDeError.includes("Sold out")) {
        mensajeEspanol = "Lo sentimos, no hay stock disponible de esta promoción en este momento.";
    } else {
        mensajeEspanol = mensajeDeError;
    }

    const txtElement = errorBanner.querySelector('.error-message-text');
    if (txtElement) {
        txtElement.textContent = mensajeEspanol;
    }
    
    errorBanner.style.display = 'flex';

    // Desvanece el error automáticamente después de 6 segundos
    setTimeout(() => {
        errorBanner.style.display = 'none';
    }, 6000);
}

// FUNCIÓN PARA SELECCIONAR OFERTAS
function seleccionarOferta(elemento) {
    // 1. Quitar la clase 'selected' de todas las tarjetas
    const tarjetas = document.querySelectorAll('.offer-card');
    tarjetas.forEach(t => t.classList.remove('selected'));

    // 2. Añadir la clase 'selected' a la tarjeta clickeada
    elemento.classList.add('selected');
    
    // Opcional: Feedback táctil (vibración suave en móviles)
    if (window.navigator.vibrate) {
        window.navigator.vibrate(10);
    }
}

// LÓGICA DEL ROLLING TICKER DE BENEFICIOS
function initPromoRoller() {
    const track = document.getElementById('promo-rolling-track');
    if (!track) return;

    let currentStep = 0;
    const totalSteps = 3; // Tenemos 3 mensajes
    const stepHeight = 45; // Coincide con el CSS

    setInterval(() => {
        currentStep++;
        
        // Si llegamos al final, reiniciamos suavemente
        if (currentStep >= totalSteps) {
            currentStep = 0;
        }

        // Aplicamos el desplazamiento vertical
        track.style.transform = `translateY(-${currentStep * stepHeight}px)`;
    }, 3000); // Cambio cada 3 segundos
}

// Iniciar al cargar la página
window.addEventListener('DOMContentLoaded', initPromoRoller);


function updateRollingClock(duration) {
    let timer = duration;
    
    const h1 = document.getElementById('h1');
    const h2 = document.getElementById('h2');
    const m1 = document.getElementById('m1');
    const m2 = document.getElementById('m2');
    const s1 = document.getElementById('s1');
    const s2 = document.getElementById('s2');

    if (!h1 || !h2 || !m1 || !m2 || !s1 || !s2) return;

    function renderTime() {
        let hours = parseInt(timer / 3600, 10);
        let minutes = parseInt((timer % 3600) / 60, 10);
        let seconds = parseInt(timer % 60, 10);

        let hStr = hours.toString().padStart(2, '0');
        let mStr = minutes.toString().padStart(2, '0');
        let sStr = seconds.toString().padStart(2, '0');

        const unitHeight = 28;

        h1.style.transform = `translateY(-${hStr[0] * unitHeight}px)`;
        h2.style.transform = `translateY(-${hStr[1] * unitHeight}px)`;
        m1.style.transform = `translateY(-${mStr[0] * unitHeight}px)`;
        m2.style.transform = `translateY(-${mStr[1] * unitHeight}px)`;
        s1.style.transform = `translateY(-${sStr[0] * unitHeight}px)`;
        s2.style.transform = `translateY(-${sStr[1] * unitHeight}px)`;
        
        const cartTimerEl = document.getElementById('cart-header-timer');
        if (cartTimerEl) cartTimerEl.textContent = `${hStr}:${mStr}:${sStr}`;

        if (--timer < 0) timer = duration;
    }

    // 1. Ejecución instantánea a 0ms (elimina el "00:00:00")
    renderTime();

    // 2. Continúa descontando segundo a segundo
    setInterval(renderTime, 1000);
}

// Iniciar inmediatamente en cuanto el DOM esté listo (no espera a los videos pesados)
document.addEventListener('DOMContentLoaded', function() {
    let twoHoursPlus = 60 * 60 * 2 + 60 * 23 + 42; 
    updateRollingClock(twoHoursPlus);
});


// Agrega esto al final de script.js para animar la barra de envío al hacer scroll
document.addEventListener('DOMContentLoaded', function() {
    const progressBar = document.querySelector('.progress-bar-fill');
    if (progressBar) {
        // Pausar animación inicial por CSS
        progressBar.style.animation = 'none';
        
        // Configurar un observador
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Reactivar animación exactamente cuando entra en pantalla
                    progressBar.style.animation = 'fillTimeline 1.5s ease-out forwards';
                    observer.disconnect(); // Para que solo se anime la primera vez
                }
            });
        }, { threshold: 0.5 });
        
        observer.observe(document.querySelector('.tracking-timeline-pro'));
    }
});

// FORZAR AUTOPLAY EN IPHONE
window.addEventListener('load', function() {
    const videos = document.querySelectorAll('video');
    
    videos.forEach(video => {
        // Intentar reproducir automáticamente
        const playPromise = video.play();

        if (playPromise !== undefined) {
            playPromise.then(_ => {
                // Autoplay funcionó perfectamente
                console.log("Autoplay iniciado");
            }).catch(error => {
                // El autoplay fue bloqueado, intentamos de nuevo al primer toque
                console.log("Autoplay bloqueado por el sistema, reintentando...");
                document.body.addEventListener('touchstart', function() {
                    video.play();
                }, {once: true});
            });
        }
    });
});


// Actualizar el año de copyright dinámicamente
document.addEventListener("DOMContentLoaded", function() {
    const yearElement = document.getElementById("footer-year");
    if (yearElement) {
        yearElement.textContent = new Date().getFullYear();
    }
});

// Detectar si el usuario viene de regreso desde el checkout/cart y abrir el drawer
document.addEventListener("DOMContentLoaded", function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('open_cart') === 'true') {
        abrirCarritoManual(); 
    }
});
















// =============================================================================
// BLOQUE UNIFICADO DE CABECERA, LOGO, CARRITO Y BOTÓN FLOTANTE (NIDA COMPLETO)
// =============================================================================
function inicializarFuncionesNida() {
    console.log("🚀 NIDA: script.js cargado e inicializado con éxito");

    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index';

    // ---------------------------------------------------------
    // A. LÓGICA DE CARGA DINÁMICA EXCLUSIVA PARA EL INICIO (HOME)
    // ---------------------------------------------------------
    if (isHomePage && window.NidaActiveConfig) {
        const activeConfig = window.NidaActiveConfig;

        // 1. Cargar el video de fondo dinámico de forma limpia (Con respaldo CDN forzado)
        const heroVideo = document.getElementById('hero-video-chameleon');
        if (heroVideo) {
            const videoSrc = (activeConfig && activeConfig.heroVideo && activeConfig.heroVideo !== "") ? activeConfig.heroVideo : "https://cdn.shopify.com/videos/c/o/v/39b289bc2d4448f992bbfd869e9c8935.mp4";
            heroVideo.innerHTML = `<source src="${videoSrc}" type="video/mp4">`;
            heroVideo.load();
            heroVideo.play().catch(e => console.log("Autoplay iniciado:", e));
        }

        // 2. Actualizar el enlace del botón del Hero principal
        const heroBtn = document.getElementById('hero-btn-chameleon');
        if (heroBtn) {
            heroBtn.href = (activeConfig && activeConfig.productUrl && activeConfig.productUrl !== "") ? activeConfig.productUrl : "/products/linna-collagen-22-plus";
        }

        // 3. Actualizar el enlace del botón al final de la línea de tiempo
        const timelineBtn = document.getElementById('timeline-btn-chameleon');
        if (timelineBtn) {
            timelineBtn.href = (activeConfig && activeConfig.productUrl && activeConfig.productUrl !== "") ? activeConfig.productUrl : "/products/linna-collagen-22-plus";
        }

        // 4. Actualizar el enlace de la flecha de volver en la cabecera
        const backArrow = document.querySelector('.custom-back-arrow-trigger');
        if (backArrow) {
            backArrow.href = activeConfig.productUrl;
        }
    }

    // ---------------------------------------------------------
    // B. COMPORTAMIENTO HÍBRIDO DEL BOTÓN DEL CARRITO DEL HEADER
    // ---------------------------------------------------------
    const cartBtnHeader = document.querySelector('.cart-btn') || 
                          document.querySelector('.header-actions__action[href*="/cart"]') || 
                          document.querySelector('.header__icon--cart') ||
                          document.querySelector('a[href="/cart"]') ||
                          document.querySelector('.custom-cart-trigger');

    if (cartBtnHeader) {
        cartBtnHeader.onclick = null; 
        
        if (isHomePage) {
            cartBtnHeader.addEventListener('click', function(event) {
                event.preventDefault();
                // Redirige dinámicamente al producto activo con su ancla de compra
                const redirectUrl = window.NidaActiveConfig ? window.NidaActiveConfig.productUrl + '#compra' : '/products/linna-collagen-22-plus#compra';
                window.location.href = redirectUrl;
            });
        } else {
            cartBtnHeader.addEventListener('click', function(event) {
                event.preventDefault();
                toggleCart();
            });
        }
    }

    // ---------------------------------------------------------
    // C. COMPORTAMIENTO HÍBRIDO DEL LOGO CENTRADO DEL HEADER
    // ---------------------------------------------------------
    // 2. COMPORTAMIENTO HÍBRIDO DE ENLACES DE RETORNO Y LOGO EN LA CABECERA
    if (isHomePage) {
        // --- COMPORTAMIENTO EN LA PÁGINA DE INICIO (HOME) ---
        const tickerLogo = document.querySelector('.ticker-logo');
        if (tickerLogo) {
            const logoLink = tickerLogo.closest('a') || tickerLogo;
            logoLink.onclick = null;
            logoLink.addEventListener('click', function(event) {
                event.preventDefault();
                const redirectUrl = window.NidaActiveConfig ? window.NidaActiveConfig.productUrl + '#compra' : '/products/linna-collagen-22-plus#compra';
                window.location.href = redirectUrl;
            });
        }
    } else {
        // --- COMPORTAMIENTO EN LA PÁGINA DE PRODUCTO (VINCULAR TODO AL ORIGEN) ---
        // Detectamos el handle del producto de la URL de forma segura (compatible con /en/)
        const path = window.location.pathname;
        const match = path.match(/\/products\/([a-zA-Z0-9\-]+)/);
        const productHandle = match ? match[1] : null;

        if (productHandle) {
            // Buscamos CUALQUIER enlace en la cabecera que apunte al inicio (Logo, flechas de volver, etc.)
            const headerLinks = document.querySelectorAll('header-component a, .top-header a, .top-header-bold a, .header__icon--menu, .custom-back-arrow-trigger');
            
            headerLinks.forEach(link => {
                const href = link.getAttribute('href');
                // Si el enlace apunta a la raíz (con o sin idioma) o tiene las clases de volver
                if (href === '/' || href === '/en' || href === '/en/' || link.classList.contains('custom-back-arrow-trigger') || link.classList.contains('header__icon--menu')) {
                    link.onclick = null; // Eliminamos cualquier acción previa del tema
                    link.addEventListener('click', function(event) {
                        event.preventDefault();
                        event.stopPropagation(); // Evitamos que otros scripts de la plantilla interfieran
                        window.location.href = `/?origen=${productHandle}`;
                    }, true); // Fase de captura (true) para ganarle en prioridad al tema
                }
            });
        }
    }

    // ---------------------------------------------------------
    // D. BOTÓN FLOTANTE MÓVIL EN SCROLL
    // ---------------------------------------------------------
    const stickyBtn = document.getElementById('sticky-cta-mobile');
    const compraSection = document.getElementById('compra') || document.querySelector('.mega-promos-container');
    
    if (stickyBtn) {
        // Ocultamos el botón de inmediato al arrancar la página vía JS (evita bloqueos del CSS)
        stickyBtn.style.display = 'none';

        window.addEventListener('scroll', function() {
            const isMobile = window.innerWidth < 750;
            
            // Si es pantalla de PC, lo mantenemos oculto y salimos de la función
            if (!isMobile) {
                stickyBtn.style.display = 'none';
                return;
            }

            const scrollPos = window.scrollY;

            // CONTROL DE SEGURIDAD (Para tu página de Inicio):
            // Si no hay sección de compras locales, usamos el filtro de scroll simple de 450px
            if (!compraSection) {
                if (scrollPos > 450) {
                    stickyBtn.style.display = 'flex';
                    // Re-direccionamos el botón flotante del Inicio hacia el producto activo
                    const floatBtn = stickyBtn.querySelector('button');
                    if (floatBtn && window.NidaActiveConfig) {
                        floatBtn.onclick = function() {
                            window.location.href = window.NidaActiveConfig.productUrl + '#compra';
                        };
                    }
                } else {
                    stickyBtn.style.display = 'none';
                }
                return;
            }

            // CONTROL AVANZADO DE VISIBILIDAD (Para tu página de Producto):
            // Posicionamiento absoluto ultra-estable e independiente de la altura
            const rect = compraSection.getBoundingClientRect();
            const absoluteTop = rect.top + scrollPos;
            const absoluteBottom = absoluteTop + compraSection.offsetHeight;
            
            // Definimos con precisión los límites de entrada y salida de las ofertas
            const inicioOfertas = absoluteTop - window.innerHeight + 100;
            const finOfertas = absoluteBottom - 50;

            const estaViendoOfertas = (scrollPos > inicioOfertas) && (scrollPos < finOfertas);

            if (scrollPos > 450 && !estaViendoOfertas) {
                stickyBtn.style.display = 'flex';
            } else {
                stickyBtn.style.display = 'none';
            }
        }, { passive: true });
    }
}

// --- EVITAR EL RETRASO DE CARGA DE SHOPIFY (document.readyState) ---
if (document.readyState === "interactive" || document.readyState === "complete") {
    inicializarFuncionesNida();
} else {
    document.addEventListener("DOMContentLoaded", inicializarFuncionesNida);
}

// --- LÓGICA DE AMPLIAR IMÁGENES (LIGHTBOX) ---
function openLightbox(imgElement) {
    const modal = document.getElementById('image-lightbox-modal');
    const expandedImg = document.getElementById('lightbox-expanded-img');
    if (modal && expandedImg && imgElement) {
        expandedImg.src = imgElement.src;
        expandedImg.alt = imgElement.alt || 'Imagen ampliada';
        modal.classList.add('show');
        if (window.navigator.vibrate) window.navigator.vibrate(12);
    }
}

function closeLightbox() {
    const modal = document.getElementById('image-lightbox-modal');
    if (modal) modal.classList.remove('show');
}

// Asigna automáticamente el evento de ampliar a las fotos de las reseñas e imágenes
document.addEventListener("DOMContentLoaded", function() {
    document.body.addEventListener('click', function(e) {
        if (e.target && (e.target.classList.contains('review-img') || e.target.classList.contains('ba-image'))) {
            openLightbox(e.target);
        }
    });
});